import PropTypes from 'prop-types';
import React from 'react';
import { Tab, Tabs } from 'react-toolbox';
import { ThemeProvider } from 'react-css-themr';
import UserDetailsCard from 'components/users/UserDetailsCard';
import UserDetailsBasicInfo from 'components/users/UserDetailsBasicInfo';
import UserDetailsBadgeInfo from 'components/users/UserDetailsBadgeInfo';
import UserDetailsRow from 'components/users/UserDetailsRow';
import UserDetailsElement from 'components/users/UserDetailsElement';
import EmployableHistory from '../../../../../shared/components/EmployableHistory';
import { can } from '../../../../../services';
import EmployeeType from 'types/employee';
import RTTabs from 'styles/tabs';

const detailsTheme = { RTTabs };

const EmployeeDetailsCard = ({ employee, role, position = '', mvw = {},
                                activeTab, onTabChange }) => {
  const assignedInstallers = employee.assigned_installers || [];
  return (
    <ThemeProvider theme={detailsTheme}>
      <UserDetailsCard user={employee} type="employees" role={role} resource={'employee'}>
        <Tabs index={activeTab} onChange={onTabChange} className={RTTabs.headersOnlyTabs}>
          <Tab label="Basic Info">
            <UserDetailsBasicInfo
              user={employee}
              leadCertField
              contractorTableApprovedField
              canDeliverField
              role={role}
            />
            <UserDetailsBadgeInfo user={employee} />
            {can(role, 'view', 'SUPERVISOR_INFO', { position, mvw }) && assignedInstallers.length > 0 && (
              <UserDetailsRow title="Assigned Installers">
                <UserDetailsElement
                  title="Installers"
                  value={assignedInstallers.join(', ')}
                />
              </UserDetailsRow>
            )}
          </Tab>
          <Tab label="History">
            <EmployableHistory employable={employee} employableType={'employee'} />
          </Tab>
        </Tabs>
      </UserDetailsCard>
    </ThemeProvider>
  );
};

EmployeeDetailsCard.propTypes = {
  employee: EmployeeType.isRequired,
  role: PropTypes.string,
  position: PropTypes.string,
  mvw: PropTypes.object,
  activeTab: PropTypes.number,
  onTabChange: PropTypes.func,
};

export default EmployeeDetailsCard;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/employees/components/employeeDetailsCard.jsx